import {
  FREE_USER_JOB_PITCH_LIMIT,
  VERY_POPULAR_PITCH_COUNT,
} from 'constants/constants';

/**
 * Status the job-page pill shows: closed, priority, popular, veryPopular, open.
 * Popular means more pitches than the free-account limit, and not closed or boosted.
 * @param {object} brief
 * @param {boolean} [isExpired]
 * @returns {'closed'|'priority'|'popular'|'veryPopular'|'open'}
 */
export function getJobPostingStatus(brief, isExpired = false) {
  if (!brief || isExpired || !brief.active) {
    return 'closed';
  }
  if (brief.boosted_expires_at) {
    return 'priority';
  }
  if (brief.num_of_pitches > FREE_USER_JOB_PITCH_LIMIT) {
    return brief.num_of_pitches >= VERY_POPULAR_PITCH_COUNT
      ? 'veryPopular'
      : 'popular';
  }
  return 'open';
}

/**
 * True when the job-page status pill would say Popular or Very popular.
 * @param {object} brief
 * @param {boolean} [isExpired]
 * @returns {boolean}
 */
export function isJobPopular(brief, isExpired = false) {
  const status = getJobPostingStatus(brief, isExpired);
  return status === 'popular' || status === 'veryPopular';
}
